const styles = (theme) => ({
  root: {
    overflow: 'hidden',
    width: '100%',
    position: 'absolute',
    height: '100%',
  },
  padding: {
    // Height of bottom nav
    paddingBottom: theme?.mixins?.toolbar?.minHeight,
  },
});

export default styles;
